import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { CategoryForm } from "@univdiam/ui/customComponents/CategoryList/CategoryForm"
import api from '@/http/api'

export default function EditCategory() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [initialData, setInitialData] = useState(null)

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await api.get(`/api/category/${id}`)
        if (response.status === 200 && response.data) {
          const category = response.data.data
          // Map fields to your form shape
          setInitialData({
            category_id: category.category_id,
            name: category.name,
            status: category.status === 1 ? "1" : "0"  
          })
        }
      } catch (err) {
        console.error("Failed to fetch category", err)
        alert("Error fetching category.")
        navigate("/category")
      }
    }

    fetchCategory()
  }, [id, navigate])

  const handleUpdateCategory = async (data: any) => {
    try {
      const response = await api.put(`/api/category/${id}`, data)
      if (response.status === 200) {
        alert("Category updated successfully!")
        navigate("/category")
      }
    } catch (error) {
      console.error("Error updating category:", error)
      alert("Failed to update category.")
    }
  }

  if (!initialData) return <p className="text-center p-10">Loading...</p>

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit Category</h1>
      <CategoryForm onSubmit={handleUpdateCategory} initialValues={initialData} isEdit />
    </div>
  )
}
